import { Cancel, Save } from "@mui/icons-material";
import { CircularProgress } from "@mui/material";
import { Formik } from "formik";
import { isEmpty } from "lodash";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Api from "../../../api2";
import Helper from "../../../helpers";
import { commonReducerSelector, userSelector } from "../../../redux/selector";
import {
  MyBreadCrumbs,
  MyButton,
  MyForm,
  MyTable,
  MyThaoTac,
  ThongBao,
  scrollToError
} from "../../Lib/componentLibrarys";
import { ValidateSchemaAdd, ValidateSchemaUpdate } from "./validate";
import { FormNhapAdd, FormNhapUpdate } from "./form";
import {
  parseDataSaveAdd,
  parseDataSaveUpdate,
  propsToInitialState
} from "./models";

const RoutesQuanLyNguoiDung = [
  {
    path: "",
    main: () => <QuanLyNguoiDung />
  },
  {
    path: "add",
    main: () => <HandleQuanLyNguoiDung />
  },
  {
    path: "edit/:userName",
    main: () => <HandleQuanLyNguoiDung />
  }
];
export default RoutesQuanLyNguoiDung;

function QuanLyNguoiDung() {
  const [dataFormik, setFormik] = useState({
    search: "",
    limit: 10,
    anchor: null
  });
  const [rawData, setRawData] = useState({});
  const [Count, setCount] = useState();
  const [data, setData] = useState([]);
  const formikRef = useRef();
  //for table method
  const navigate = useNavigate();

  const parseSearchForm = values => {
    const tuKhoa = values?.search?.length > 0 ? values?.search : "";
    const limit = values?.limit ? values.limit : 10;
    const anchor = values?.anchor ? values.anchor : "";
    const page = values?.page || "";
    return { tuKhoa, limit, anchor, page };
  };

  useEffect(() => {
    const values = formikRef.current?.values;
    getApi(parseSearchForm(values));
  }, []);
  const getRows = (limit, anchor, page) => {
    const values = formikRef.current?.values;
    getApi(parseSearchForm({ ...values, limit, anchor, page }));
  };

  const getApi = ({ tuKhoa, limit, anchor, page }) => {
    new Api()
      .GetListQuanLyNguoiDung({ tuKhoa, limit, anchor })
      .then(res => {
        if (res.code === 200) {
          setData(
            Helper.addSttToTableDataSource(res.data.records, page, limit)
          );
          setRawData(res.data);
        }
        if (res.data?.count) {
          setCount(res.data?.count);
        }
      })
      .catch(err => {});
  };
  const onSubmitSearch = () => {
    const values = formikRef.current?.values;
    getApi(parseSearchForm(values));
  };
  const columns = ({ handleEdit, handleDelete }) => {
    var column = [
      {
        headerName: "STT",
        field: "stt",
        width: "100px",
        suppressSizeToFit: true,
        pinned: "left",
        cellStyle: { justifyContent: "center" },
        headerClass: "ag-grid-header-center"
      },
      { headerName: "UserName", field: "userName", width: "230px" },
      { headerName: "Họ tên", field: "fullName", width: "250px" },
      {
        field: "phongBan",
        headerName: "Phòng ban",
        width: "250px",
        cellRendererFramework: prams => {
          return prams?.data?.phongBan?.ten;
        }
      },
      {
        field: "chucVu",
        headerName: "Chức vụ",
        minWidth: 250,
        flex: 1,
        cellRendererFramework: prams => {
          return prams?.data?.chucVu?.ten;
        }
      },
      {
        headerName: "Thao tác",
        width: "100px",
        pinned: "right",
        cellStyle: { justifyContent: "center" },
        cellRendererFramework: prams => (
          <MyThaoTac
            prams={prams}
            handleDelete={handleDelete}
            handleEdit={handleEdit}
          />
        ),
        headerClass: "ag-grid-header-center"
      }
    ];
    return column;
  };

  const handleEdit = params => {
    if (!params?.userName) {
      ThongBao({ status: "warn", message: "UserName không tồn tại" });
    }
    navigate(`edit/${params?.userName || undefined}`);
  };
  const handleAdd = data => {
    navigate(`add`);
  };
  const handleDelete = params => {
    new Api()
      .DeleteQuanLyNguoiDungByUserName({ userName: params?.userName })
      .then(res => {
        if (res.code === 200) {
          const values = formikRef.current.values;
          getApi(parseSearchForm(values));
          ThongBao({ status: "success", message: "Xóa thành công" });
        }
      })
      .catch(err => {});
  };

  return (
    <div className="divMain">
      <MyBreadCrumbs
        title={[{ name: "Quản trị hệ thống" }, { name: "Quản lý người dùng" }]}
      />
      <MyForm
        formikRef={formikRef}
        showSearch={true}
        dataFormik={dataFormik}
        handleAdd={handleAdd}
        editable={true}
        onSubmitAPI={onSubmitSearch}
        marginBottom={"15px"}
      />
      <MyTable
        autofit={true}
        columns={columns({
          editable: true,
          handleEdit: handleEdit,
          handleDelete: handleDelete
        })}
        data={data}
        pagination={{
          rawData: rawData,
          setData: setData,
          getRows: getRows,
          Count: Count
        }}
      />
    </div>
  );
}

function HandleQuanLyNguoiDung() {
  const navigate = useNavigate();
  const user = useSelector(userSelector);
  const [isLoading, setIsLoading] = useState(false);
  const { userName } = useParams();
  const [data, setData] = useState(null);
  const common = useSelector(commonReducerSelector);
  const dataDanhMuc = common?.danhmucs?.data;
  const profile = common?.profile?.data;
  const [chucVuList, setChucVuList] = useState([]);
  const [phongBanList, setPhongBanList] = useState([]);
  const [coQuanQuanLyList, setCoQuanQuanLyList] = useState([]);
  const [rolesByCapList, setRolesByCapList] = useState([]);
  const [doanhNghiepList, setDoanhNghiepList] = useState([]);

  const formRef = useRef(null);

  //ref just for use scroll when error validate
  const refI = useRef(null);

  useEffect(() => {
    if (userName && !data) {
      setIsLoading(true);
      new Api()
        .GetQuanLyNguoiDungByUserName({ userName: userName })
        .then(data => {
          if (data.code === 200) {
            setData(data?.data?.result);
          }
        })
        .catch(err => {})
        .finally(() => {
          setIsLoading(false);
        });
    }
    if (isEmpty(chucVuList)) {
      new Api().GetChucVuList().then(data => {
        if (data.code === 200) {
          setChucVuList(data?.data?.result?.data);
        }
      });
    }
    if (isEmpty(phongBanList)) {
      new Api().GetPhongBanList().then(data => {
        if (data.code === 200) {
          setPhongBanList(data?.data?.result?.data);
        }
      });
    }
    if (isEmpty(coQuanQuanLyList)) {
      new Api().GetCoQuanQuanLyList().then(data => {
        if (data.code === 200) {
          setCoQuanQuanLyList(data?.data?.result?.data);
        }
      });
    }
    if (isEmpty(rolesByCapList)) {
      new Api().GetRolesByCapList().then(data => {
        if (data.code === 200) {
          setRolesByCapList(data?.data?.result);
        }
      });
    }
    if (isEmpty(doanhNghiepList)) {
      new Api().GetListSelectDoanhNghiep({}).then(data => {
        if (data.code === 200) {
          setDoanhNghiepList(data?.data);
        }
      });
    }
  }, [userName]);

  if (isLoading) {
    return (
      <div className="style-loading">
        <CircularProgress />
      </div>
    );
  }

  //set initial data
  const initialState = propsToInitialState(
    data,
    chucVuList,
    phongBanList,
    coQuanQuanLyList,
    rolesByCapList,
    profile
  );

  //List form
  const formNhap = (
    <Formik
      innerRef={f => (formRef.current = f)}
      i
      initialValues={initialState}
      enableReinitialize={true}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={userName ? ValidateSchemaUpdate : ValidateSchemaAdd}
    >
      {({ values, errors, handleSubmit, setFieldValue }) => (
        <form onSubmit={handleSubmit}>
          {/* div just for use scroll when error validate */}
          <div ref={refI}></div>
          {userName ? (
            <FormNhapUpdate
              values={values}
              errors={errors}
              setFieldValue={setFieldValue}
              chucVuList={chucVuList}
              phongBanList={phongBanList}
              coQuanQuanLyList={coQuanQuanLyList}
              rolesByCapList={rolesByCapList}
              doanhNghiepList={doanhNghiepList}
            />
          ) : (
            <FormNhapAdd
              values={values}
              errors={errors}
              setFieldValue={setFieldValue}
              chucVuList={chucVuList}
              phongBanList={phongBanList}
              coQuanQuanLyList={coQuanQuanLyList}
              rolesByCapList={rolesByCapList}
              doanhNghiepList={doanhNghiepList}
            />
          )}
        </form>
      )}
    </Formik>
  );

  //handle when submit API
  const handleSaveUpdate = async () => {
    await formRef.current.validateForm();

    if (!isEmpty(formRef.current.errors)) {
      scrollToError(refI);
      ThongBao({
        status: "warn",
        message: "Yêu cầu nhập đầy đủ các trường có dấu đỏ"
      });
      return;
    }

    new Api()
      .Update_QuanLyNguoiDung({
        token: user.access_token,
        data: parseDataSaveUpdate(formRef.current.values)
      })
      .then(res => {
        if (!res || res.code !== 200) {
          //TODO
          ThongBao({ status: "error", message: "Đã có lỗi xảy ra" });
          return;
        }
        ThongBao({ status: "success", message: res?.data });
        navigate(-1);
      })
      .catch(err => {
        ThongBao({ status: "error", message: "Đã có lỗi xảy ra" });
      })
      .finally(() => {});
  };

  const handleSaveAdd = async () => {
    await formRef.current.validateForm();

    if (!isEmpty(formRef.current.errors)) {
      scrollToError(refI);
      ThongBao({
        status: "warn",
        message: "Yêu cầu nhập đầy đủ các trường có dấu đỏ"
      });
      return;
    }

    new Api()
      .Add_QuanLyNguoiDung({
        token: user.access_token,
        data: parseDataSaveAdd(formRef.current.values)
      })
      .then(res => {
        if (!res || res.code !== 200) {
          //TODO
          ThongBao({ status: "error", message: "Đã có lỗi xảy ra" });
          return;
        }
        ThongBao({ status: "success", message: res?.data });
        navigate(-1);
      })
      .catch(err => {
        ThongBao({ status: "error", message: "Đã có lỗi xảy ra" });
      })
      .finally(() => {});
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          paddingBottom: "0.875rem"
        }}
      >
        <MyBreadCrumbs
          title={[
            { name: "Quản trị hệ thống" },
            { name: "Quản lý người dùng", link: -1 },
            { name: `${userName ? "Cập nhật " : "Thêm mới"}` }
          ]}
        />
        {formNhap}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: 15
        }}
      >
        <MyButton
          onClick={() => navigate(-1)}
          txt="Hủy bỏ"
          color="#888"
          style={{ width: 130, height: 33, marginTop: 5 }}
          icon={<Cancel />}
        />
        <p style={{ width: 5 }}></p>
        <MyButton
          onClick={() => {
            userName ? handleSaveUpdate() : handleSaveAdd();
          }}
          txt="Lưu thông tin"
          style={{ width: 130, height: 33, marginTop: 5 }}
          icon={<Save />}
        />
      </div>
    </>
  );
}
